import PropTypes from 'prop-types';

import Button from '../Button';
import MenuButton from '../MenuButton/MenuButton';

import './split-button.css';

/**
 * SplitButton UI component
 */
const SplitButton = ({ actionItems, disabled, variant }) => {
  // store the first item as the primary action
  const primaryAction = actionItems[0];

  // Render the output
  return (
    <span className={`pds-split-button pds-split-button--${variant}`}>
      <Button
        aria-disabled={disabled ? true : undefined}
        className="pds-split-button__primary-action"
        disabled={disabled}
        label={primaryAction.label}
        onClick={() => primaryAction.callback(primaryAction)}
        variant={variant}
      />
      <MenuButton
        aria-disabled={disabled ? true : undefined}
        className="pds-split-button__menu-button"
        disabled={disabled}
        listboxPositionInitial="bottom-end"
        menuItems={actionItems}
        variant={variant}
      />
    </span>
  );
};

//
// Prop types

const ActionItemType = PropTypes.exact({
  /**
   * Label for a menu item
   */
  label: PropTypes.string.isRequired,
  /**
   * Callback function to execute when menu item is clicked/tapped/activated
   */
  callback: PropTypes.func.isRequired,
});

//
// Component propType definitions
SplitButton.propTypes = {
  /**
   * Array of menu items
   */
  actionItems: PropTypes.arrayOf(ActionItemType).isRequired,
  /**
   * Is the button disabled?
   */
  disabled: PropTypes.bool,
  /**
   * Button style variant.
   */
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

SplitButton.defaultProps = {
  disabled: false,
  variant: 'secondary',
};

//
export default SplitButton;
